// extracted by mini-css-extract-plugin
module.exports = {"onecol-four-stories-container":"_3h-v6","wrapper":"_16coP","first-wrapper":"NXWo8"};